module.exports = __webpack_public_path__ + "static/media/rectangle2.f5532b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/rectangle2.png
// module id = 63
// module chunks = 0